import React from 'react'
import styled from 'styled-components'
import { Tooltip } from '../../common'
import { INTEGRAL_LP_FARMING_URL } from '../../constants'

export function AccruedLpRewardsTooltip() {
  return (
    <TooltipStyled right>
      <p>Your LP rewards for this pool.</p>
      <p>
        Learn more{' '}
        <a href={INTEGRAL_LP_FARMING_URL} target="_blank">
          here
        </a>
        .
      </p>
    </TooltipStyled>
  )
}

const TooltipStyled = styled(Tooltip)`
  width: 220px;
`
